// extracted by mini-css-extract-plugin
module.exports = {"logoSpin":"LoopSpinner_logoSpin__3iIYL","spin":"LoopSpinner_spin__25MUW"};